import { faCalendar } from '@fortawesome/pro-light-svg-icons';
import { StyledCalendarIcon } from 'components/headers/styles';
import { MobileBookingsText, MobileTitleBookings, MobileTitleContainer } from '../styles';
import { useHeader } from 'pages/resources/components/hooks/use-header.hook';
import React from 'react';
import { useIntl } from 'react-intl';

export const MobileTitle = (): JSX.Element => {
  const { onMyBookingsClick } = useHeader();
  const intl = useIntl();

  return (
    <MobileTitleContainer data-testid="mobile-header">
      <MobileTitleBookings onClick={onMyBookingsClick}>
        <StyledCalendarIcon icon={faCalendar} data-testid="my-bookings-button" />
        <MobileBookingsText>{intl.formatMessage({ id: 'my_bookings' })}</MobileBookingsText>
      </MobileTitleBookings>
    </MobileTitleContainer>
  );
};
